import { Shinsei, Sonota } from "@/types/Shinsei";
import { reactive } from "vue";

export function useInit(form: Shinsei) {

  let sonota: Sonota[] = reactive([{
    shinsei_date: null,
    mst_teate_id: null,
    teate_name: null,
  }]);

  if(form.sonota){
    sonota = form.sonota;
  }else{
    form.sonota = sonota;
  }
  
  return {
    sonota,
  }
}
